/*
* @Author: yongwenhao
* @Date: 2020-04-07 11:35:22
* @describe: 呼叫中心
*/
<template>
    <ItemWarp :dataInfo="dataInfo"></ItemWarp>
</template>

<script>
    import serviceData from '../../js/data'
    import ItemWarp from './components/item-warp'

    export default {
        name: "cc",
        props: {},
        components: {ItemWarp},
        data() {
            return {
                dataInfo: serviceData.cc
            }
        }
    }
</script>

<style lang='less' scoped>
/deep/ .info-content {
    max-width: 410px;
}
</style>